import axios from 'axios';
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Form } from 'reactstrap';
import EmptyTable from '../../../components/errorComponents/EmptyTable';
import InvestorModal from '../../../components/Modal/InvestorModal';
import SuccessPopups from '../../../components/Popups/SuccessPopups';
import user from "../../../images/blank-user.webp"
import WarningPopup from '../../../components/Popups/WarningPopup';
import Table from '../../../components/Table';
import { environment } from '../../../env';
import { warningModalToggle } from '../../../redux/actions/Index';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import _ from "lodash";
import AddPocModal from '../../../components/Modal/AddPocModal';
import { Eye, MagnifyingGlass, Trash } from '@phosphor-icons/react';
import InvestorUploadModal from '../../../components/Modal/InvestorUploadModal';
import PathName from '../../../components/PathName/PathName';
import { useRef } from 'react';
import { ArrowSquareLeft, ArrowSquareRight } from 'iconsax-react';

const Investors = () => {
    const [investordata, setInvestorData] = useState()
    const [pageNo, setPageNo] = useState(1)
    const [records, setRecords] = useState(10)
    const [nextIsValid, setNextIsValid] = useState(false);
    const [prevIsValid, setPrevIsValid] = useState(false);
    const [update, setUpdate] = useState(false)
    const [forceRender, setForceRender] = useState(false)
    const apiTimeOut = useRef(null);

    const userProject = useSelector((state) => state?.ModalReducer?.userproject);
    const user = useSelector((state) => state?.Reducers?.userdata);

    const dispatch = useDispatch()

    const {
        register,
        handleSubmit,
        watch,
        getValues,
        setValue,
        formState: { errors },
    } = useForm();

    let query = watch("query")

    const onSearchHandeler = useCallback(
        _.debounce((_searchVal) => {
          Search(_searchVal)
        }, 2000),
    [userProject] );

    const Search = async (query) => {
        if ((typeof query) == "object") {
            query = query?.query;
        }
        setForceRender(true);
        const SearchUrl = `${environment.baseUrl}get-investors/?p=1&records=${records}&project=${userProject}&investor=${query}`;
        if(pageNo != 1){
            setPageNo(1)
        }
        await axios(SearchUrl).then((res) => {
            let data = res.data.results
            if(res?.data?.next != null){
                setNextIsValid(true)
            }else if(res?.data?.next == null){
                setNextIsValid(false)
            }
            
            if(res?.data?.previous != null){
                setPrevIsValid(true)
            }else if(res?.data?.previous == null){
                setPrevIsValid(false)
            }
            if (data.length > 0) {
                setInvestorData(data);
            } else {
                setInvestorData([])
                getInvestorDataOptimized(1, undefined, true) 
                toast.info(' Investor not found !', {
                    position: toast.POSITION.TOP_CENTER
                });
            }
            setForceRender(false);

        }).catch(e => {
            console.log(e);
            setForceRender(false);
        })
    }

    const getInvestorDataOptimized = (localPageNo, localRecord, behaveLkRest = false) => {
        if (apiTimeOut.current) {
            clearTimeout(apiTimeOut.current);
        }
        apiTimeOut.current = setTimeout(() => {
            let url = "";
            if(localPageNo != undefined){
                url = `${environment.baseUrl}get-investors/?p=${localPageNo}&records=${records}&project=${userProject}&investor=${query == undefined ? "" : (behaveLkRest ? "" : query)}`;
            }else if( localRecord != undefined){
                url = `${environment.baseUrl}get-investors/?p=1&records=${localRecord}&project=${userProject}&investor=${query == undefined ? "" : (behaveLkRest ? "" : query)}`;
            }
            axios.get(url).then(res => {
                if(res?.data?.next != null){
                    setNextIsValid(true)
                }else if(res?.data?.next == null){
                    setNextIsValid(false)
                }

                if(res?.data?.previous != null){
                    setPrevIsValid(true)
                }else if(res?.data?.previous == null){
                    setPrevIsValid(false)
                }

                setInvestorData(res.data?.results)
            }).catch(res => {
                setInvestorData([])
                console.log("error");
            })
            apiTimeOut.current = null;
        }, 100);
    }

    const deleteProjectData = (id) => {
        dispatch(warningModalToggle(id));
    };

    const deleteData = (id) => {
        axios.delete(`${environment.baseUrl}editinvestor/${id}`).then(res => {
            if (res.data.code === 200) {
                Search(getValues('query'))
                dispatch(warningModalToggle())
                toast.success(res.data.message, {
                    position: toast.POSITION.TOP_CENTER
                })
            } else {
                dispatch(warningModalToggle())
                toast.error(res.data.message, {
                    position: toast.POSITION.TOP_CENTER
                })
            }
        })
            .catch(res => {
                console.log("error");

            })

    };

    useEffect(() => {
        getInvestorDataOptimized(1, undefined);//call for page
    }, [update, userProject])

    const columns = [
        // {
        //     name: 'Profile',
        //     selector: row => <div className='investors-box-img'><img src={row.image ? row.image : user} alt={row.name} className="investors-box-img-fit" /></div>,
        //     style: {
        //         fontSize: "2.6rem",
        //     }
        // },
        // {
        //     name: 'ID',
        //     selector: row => row?.id,
        //     sortable: true,
        //     style: {
        //         fontSize: "2.6rem",
        //     }
        // },
        {
            name: 'Name',
            selector: row => row?.name,
            wrap: true,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Contact No',
            selector: row => row?.contact_number,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Building No',
            selector: row => row?.building?.building_no == 'null' ? "-------------" : row?.building?.building_no,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Gala No',
            selector: row => row?.gala?.gala_no == 'null' ? "-------------" : row?.gala?.gala_no,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },

        // {
        //     name: 'Email',
        //     selector: row => row.email,
        //     sortable: true,
        //     style: {
        //         fontSize: "2.6rem",
        //     }
        // },
        // {
        //     name: 'Address',
        //     selector: row => row.address == "null" ? "-------------" : row.address.slice(0, 20),
        //     sortable: true,
        //     style: {
        //         fontSize: "2.6rem",
        //     }
        // },
        {
            name: 'Upload',
            cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
                <InvestorUploadModal investor={row.id} />

            </div>,
        },
        {
            name: 'POC',
            cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
                <AddPocModal investor={row.id} ttenant={false} />

            </div>,
        },
        {
            name: 'Action',
            cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
                <Link to={`/Investors/${row.id}`} id={row.ID} className="icon-bg-green border-0 px-2 py-3 rounded"><Eye size="28" className='icon-color-green' /></Link>
                {
                    user?.role != "user" && <>
                        <InvestorModal button='edit' title='Edit Investor' data={row} id={row.id} update={setUpdate} updateData={update} query={query} editfunction={Search} />
                        {user?.role == "superadmin" && <button onClick={() => deleteProjectData(row.id)} id={row.ID} className="icon-bg-red border-0 px-2 py-3 rounded"><Trash size="28" className='icon-color-red' /></button>}
                    </>
                }
            </div>,
        },
    ];

    const pageChangeHandler = (localPageNo) => {
        if(((pageNo < localPageNo) && nextIsValid) || ((pageNo > localPageNo) && prevIsValid)){
            getInvestorDataOptimized(localPageNo, undefined);
            setPageNo(localPageNo)
        }
    }

    const recordChangeHandler = (localRecord) => {
        getInvestorDataOptimized(undefined, localRecord);
        setRecords(localRecord)
        setPageNo(1);
    }

    return (
        <>
            <PathName />
            <SuccessPopups />
            <WarningPopup deleteData={deleteData} update={setUpdate} />
            <div className="investors-main">
                <Form onSubmit={handleSubmit(Search)}>
                    <div className='my-3 pb-1'>
                        <div className='d-flex align-items-center px-4 border-radius-10'>
                            <input
                                className='p-4 border-0 shadow-none bg-white w-100 fs-3 title-font-500 fs-2 '
                                type='text'
                                autoComplete='off'
                                placeholder='Search Investor Here...'
                                {...register('query', {
                                    onChange: (e) => onSearchHandeler(e.target.value)
                                })}
                            />
                            {/* <button type="submit" className="border-radius-7  d-flex align-items-center buttons ms-3 py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5center buttons py-4 btn btn-secondary"><span className="fs-3 d-flex gap-3 title-font-600 ps-3 pe-2">Search</span></button> */}
                            <button type="button" onClick={() => { setValue("query", ""); setInvestorData([]); getInvestorDataOptimized(1, undefined, true) }} className="border-radius-7  d-flex align-items-center buttons ms-3 py-3 px-2 py-md-3 py-lg-4 py-xl-4  px-md-4 px-lg-5 px-xl-5center buttons py-4 btn btn-secondary"><span className="fs-3 d-flex gap-3 title-font-600 ps-3 pe-2">Clear</span></button>
                        </div>
                        <br />
                    </div>
                </Form>
                {!forceRender && <div className="bg-white rounded-5 mb-5 shadow-sm  p-4 p-md-4 p-lg-5 p-xl-5">
                    <div className='d-flex justify-content-between'>
                        <div className="d-flex justify-content-between align-items-center">
                            <h1 className='mb-5 title-font-bold '>INVESTORS</h1>
                        </div>
                        <InvestorModal button='create' update={setUpdate} updateData={update} />
                    </div>
                    {investordata?.[0] === undefined ? <EmptyTable /> : <><Table investors={true} columns={columns} data={investordata} pageinationProp={true}/>
                    <div className="d-flex align-items-center justify-content-between gap-md-5 gap-lg-5 gap-xl-5  flex-column flex-md-row flex-lg-row flex-xl-row">
                        <div className="pb-3 pt-1 pb-md-5 pb-lg-5 pb-xl-5">
                            {""}
                        </div>
                        <div className='d-flex mr-2 gap-3 align-items-center justify-content-between'>
                            <select
                                className="mt-4 p-3 select-width-data-table-wo-pagination title-font-500 fs-2"
                                defaultValue={"10"}
                                {...register("recordSize", { onChange: (e) => { recordChangeHandler(e.target.value) } })}
                            >
                                <option value="8">8</option>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                            
                            </select>
                            <span onClick={() => {pageChangeHandler(pageNo - 1)}} className="fs-3 d-flex gap-3 title-font-600 ps-2 pe-1 mt-4"><ArrowSquareLeft color='#6271de' size="28" variant="Bold"/></span>
                            <span onClick={() => {pageChangeHandler(pageNo + 1)}} className="fs-3 d-flex gap-3 title-font-600 ps-2 pe-2 mt-4"><ArrowSquareRight color='#6271de' size="28" variant="Bold"/></span>
                        </div>
                        </div>
                    </>}
                </div>}
            </div>
        </>
    )
}

export default Investors